import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box, FormControlLabel, Typography } from '@mui/material';

import theme from '../../theme';
import { PRIMARY_FONT } from '../../theme/fontConstants';

import PurpleSwitch from './PurpleSwitch';

const FilterSwitch = ({
  disabled = false,
  leftLabel,
  rightLabel,
  leftValue,
  rightValue,
  currentValue,
  onValueChange,
  startAdornmentIcon,
  testId,
  wrapperSx,
}) => {
  const [isChecked, setIsChecked] = useState(currentValue === rightValue);

  useEffect(() => {
    setIsChecked(currentValue === rightValue);
  }, [currentValue, rightValue]);

  const handleChange = (event) => {
    const newChecked = event.target.checked;
    setIsChecked(newChecked);
    const newValue = newChecked ? rightValue : leftValue;
    onValueChange(newValue);
  };

  const getCurrentLabel = () => (isChecked ? rightLabel : leftLabel);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        border: `1px solid ${theme?.searchBoxForFilter?.borderColor?.focus}`,
        borderRadius: '5px',
        padding: '4px 8px',
        height: '28px',
        minWidth: '150px',
        background: 'white',
        ...wrapperSx,
      }}
    >
      {startAdornmentIcon && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '16px',
            width: '16px',
          }}
        >
          {startAdornmentIcon}
        </Box>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
        <Typography
          sx={{
            fontSize: '14px',
            fontFamily: PRIMARY_FONT[400],
            color: theme?.button?.palette?.primary,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {getCurrentLabel()}
        </Typography>

        <FormControlLabel
          control={
            <PurpleSwitch
              checked={isChecked}
              onChange={handleChange}
              disabled={disabled}
              data-testid={testId}
            />
          }
          label=""
          sx={{ margin: 0 }}
        />
      </Box>
    </Box>
  );
};

FilterSwitch.propTypes = {
  disabled: PropTypes.bool,
  leftLabel: PropTypes.string.isRequired,
  rightLabel: PropTypes.string.isRequired,
  leftValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
  rightValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  onValueChange: PropTypes.func.isRequired,
  startAdornmentIcon: PropTypes.node,
  testId: PropTypes.string,
  wrapperSx: PropTypes.shape({}),
};

export default FilterSwitch;
